import React from 'react';
import logo from '../../logo.png';
import { Text } from '../../hooks/language';
import {Button, IconButton, Container, Grid} from '@mui/material';
import styles from './footer.module.scss';
import { Facebook, Instagram } from 'iconsax-react';
//import LanguageSelector from '../components/language_selector';
//import { useContext } from 'react';
//import { LanguageContext } from '../containers/language';

export default function Footer() {

  //const languageContext = useContext(LanguageContext);
  let usingRtl = false; //languageContext.usingRtl;

  return (
    <Container className={styles.footer}>
      <Grid container className={usingRtl ? 'rtl' : ''}>

        <Grid item order={{md: 1, sm:1, xs:1}} className={styles.footerLogo}>
          <a href="/" >
            <img className="logo" src={usingRtl ? logo : logo} alt='logo' />
          </a>
        </Grid>

        <Grid item order={{md: 2, sm:2, xs:3}} sm={7} xs={12}  className={styles.footerNav}>
          <div>
            <Button href='#' color='greyPrimary' className={styles.footerLinks}>
              <Text tid="Who are we?" />
            </Button>

            <Button href='mailto:info@nsyncapp.net' color='greyPrimary' className={styles.footerLinks}>
              <Text tid="Contact Us" />
            </Button>

            <Button href='/terms-of-use' color='greyPrimary' className={styles.footerLinks}>
              <Text tid="Terms of use" />
            </Button>
          </div>
        </Grid>

        <Grid order={{md: 3, sm:3, xs:2}} item className={styles.footerSocials} >
          <IconButton href='#'>
            <Instagram size="24" color="#1D1761" variant="Bulk" />
          </IconButton>
          <IconButton href='#'>
            <Facebook size="24" color="#1D1761" variant="Bulk" />
          </IconButton>
        </Grid>

      </Grid>
      <div className={styles.copyRights}>
        <p><Text tid="All rights are reserved nS'ync App © 2023" /></p>
      </div>
    </Container>
  );
}
